module.exports = __webpack_public_path__ + "packs/media/images/Home-ffd334f2fadb6cc4dcca670c011793be.svg";